import React, { useState } from 'react'
import { render } from 'react-dom'
import { hot } from 'react-hot-loader/root'
import LinearProgress from '@material-ui/core/LinearProgress'

import './index.scss'

export const App = hot(() => {
  const [location, setLocation] = useState(window.location.href)
  const [_, setRenderCounter] = useState(1)
  const [map, setMap] = useState(new Map())

  const notifyHistoryListeners = (key, value) => {
    window.history.pushState({ [key]: value }, '', new URL(window.location))
  }

  window.showAppLoader = (where = '') => {
    if (location !== window.location.href) {
      setLocation(window.location.href)
      window.resetAppLoader()
    }
    if (!map.has(where) || !map.get(where)) {
      setMap((prevMap) => {
        prevMap.set(where, 1)
        // notifyHistoryListeners('showAppLoader', prevMap)
        return prevMap
      })
    } else {
      setMap((prevMap) => {
        prevMap.set(where, prevMap.get(where) + 1)
        // notifyHistoryListeners('showAppLoader', prevMap)
        return prevMap
      })
    }
    setRenderCounter((prev) => prev + 1)
  }

  window.hideAppLoader = (where = '') => {
    if (location !== window.location.href) {
      setLocation(window.location.href)
      window.resetAppLoader()
    }
    if (!map.has(where)) {
      return
    }
    if (map.get(where) > 1) {
      setMap((prevMap) => {
        prevMap.set(where, prevMap.get(where) - 1)
        // notifyHistoryListeners('hideAppLoader', prevMap)
        return prevMap
      })
    } else {
      setMap((prevMap) => {
        prevMap.delete(where)
        // notifyHistoryListeners('hideAppLoader', prevMap)
        return prevMap
      })
    }
    setRenderCounter((prev) => prev + 1)
  }

  window.resetAppLoader = () => {
    setMap(new Map())
    setRenderCounter(0)
  }

  window.getAppLoaderStatus = () => map

  return (
    <div className="app-loader">
      { !!map.size &&
        <LinearProgress /> }
    </div>
  )
})

window.initLoader = () => {
  render(<App />, document.getElementById('loader-app'))
}
